const request = require('superagent');


export default class ExpoController{
    getExpos(callback){
        request.get("https://sylviefayon-dessinsgravures.com/rest/getExpos.php").end((err, res) =>
        {
            if(!err){
                try{
                    let json = JSON.parse(res.text);
                    callback(null, json);
                }catch(exception){
                    callback(1, null);
                }
                
            }
            else{
                callback(err, null);
            }
        });
    }
}